import { Action } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { performAction } from 'shared/queries/perform_action'
import { convertStoreUserNonAvailability } from './shared/convert'
import keys from './shared/keys'
import { StoreUserNonAvailabilityResponse } from './shared/response'
import { StoreUserNonAvailability } from './types'

type Variables = Action

export function usePerformNonAvailabilityAction() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: mutateNonAvailabilityRequest,
    onSuccess: async data => {
      await client.invalidateQueries({ queryKey: keys.all })
    },
  })

  async function mutateNonAvailabilityRequest(
    action: Variables
  ): Promise<StoreUserNonAvailability | null> {
    const response =
      await performAction<StoreUserNonAvailabilityResponse.StoreUserNonAvailability>(
        server,
        action
      )
    return response ? convertStoreUserNonAvailability(response) : null
  }
}
